import React from 'react';
import { Divider } from 'semantic-ui-react'

const RtesNotAju1 = ({autorizacUA, styles, handleClickRegr, handleClickSel1, handleClickSel2,
  handleClickSel3, handleClickSel4}) => {
  const a152501 = autorizacUA.findIndex( autorizac => autorizac === "152501" );
  const a152505 = autorizacUA.findIndex( autorizac => autorizac === "152505" );
  const a152510 = autorizacUA.findIndex( autorizac => autorizac === "152510" );
  const a152515 = autorizacUA.findIndex( autorizac => autorizac === "152515" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
      
      <Divider inverted />

      {a152501!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
        <i className="large dollar sign violet icon"></i>
        Notas débito
      </button>
      }
      {a152505!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel2}>
        <i className="large dollar sign violet icon"></i>
        Notas crédito
      </button>
      }
      {a152510!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel3}>
          <i className="large dollar sign violet icon"></i>
          Ajustes positivos
        </button>
      }
      {a152515!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel4}>
        <i className="large dollar sign violet icon"></i>
        Ajustes negativos
      </button>
      }
    </div>
  )
};

export default RtesNotAju1
